<template>
  <Modal
    @close="$emit('close')"
    title="Cursos sin libro asignado!"
    classes="col-lg-5"
  >
    <div class="body my-1" slot="body" style="max-height: 80vh;">
      <div class="col-auto text-center">
        <div style="font-size: 20px" class="mb-3">
          Los siguientes cursos no tienen libros asignados en el mes
        </div>
        <span
          v-for="course in courses"
          :key="course.id"
          class="button mx-2 default"
          style="cursor: default;"
        >
          {{ course.name }}
        </span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import { mapState } from "vuex";

export default {
  name: "CoursesWithoutBook",
  components: {
    Modal,
  },
  props: {
    coursesWithoutBookIds: {
      type: Array,
    },
  },
  computed: {
    ...mapState(["courseList"]),
    courses() {
      if (!this.courseList) return;
      return this.courseList.filter(course =>
        this.coursesWithoutBookIds.some(courseId => courseId === course.id)
      );
    },
  },
};
</script>
